import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import SectionTitle from '@/components/ui/SectionTitle';
import { api } from '@/utils/api';
import { ObraCoverImage } from '@/components/obra/ObraCoverImage';
import { getObraImageUrl } from '@/utils/image-utils';
import { generateWorkLink } from '@/utils/utils';

const NOVEL_FAMOSAS_IDS = [
    17731, 17732, 17764, 17783, 17810, 17841, 17855, 17889, 17891,
    17916, 17917, 17920, 17923, 17941, 17942, 17947, 17950, 17953,
    17958, 17972, 17974, 17975, 17978, 17987, 17996, 18012, 18015,
    18019, 18135, 18160, 18181, 18275,
];

export default function NovelFamosasPage() {
    const [obras, setObras] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Promise.all(NOVEL_FAMOSAS_IDS.map((id) => api.get(`obras/${id}`)))
            .then((results) => setObras(results.filter((o): o is any => o != null)))
            .catch(() => setObras([]))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="min-h-screen bg-neutral-950 flex items-center justify-center"><div className="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" /></div>;

    return (
        <main className="min-h-screen bg-neutral-950 pb-20 pt-24"><div className="max-w-7xl mx-auto px-4"><div className="mb-8"><SectionTitle icon={BookOpen}>Novels maravilhosas</SectionTitle></div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
                {obras.map((obra: any) => (
                    <Link key={obra.id} to={generateWorkLink(obra.id)} className="group block">
                        <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-2 border border-white/5 hover:border-orange-500/50 transition-all shadow-lg"><ObraCoverImage src={getObraImageUrl(obra.id, obra.imagem, 520) || '/placeholder-book.jpg'} alt={obra.nome} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" /></div>
                        <h3 className="text-white text-sm font-medium line-clamp-2 text-center group-hover:text-orange-400 transition-colors uppercase italic">{obra.nome}</h3>
                    </Link>
                ))}
            </div>
            {obras.length === 0 && <div className="py-20 text-center text-white/20 uppercase font-bold tracking-widest">Nenhuma obra encontrada</div>}
        </div></main>
    );
}
